var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 4V12","stroke":"#595959","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M4 8H12","stroke":"#595959","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Plus.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
